/**
 * @generated SignedSource<<a89b1cc4483a76d88cf523a51bf256e2>>
 * @relayHash 455e9881b997edbf9a2ad2c31602916a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 09268e1658eeaa570892ced33288a2210123505bca3c18bae5ebb8871931661b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type hasDevelopmentInProjectQuery$variables = {
  projectAri: string;
  updatedFrom?: AGG$DateTime | null | undefined;
};
export type hasDevelopmentInProjectQuery$data = {
  readonly devOps: {
    readonly ariGraph: {
      readonly branchRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly buildRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly prRelationships: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "AriGraphRelationship";
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type hasDevelopmentInProjectQuery = {
  response: hasDevelopmentInProjectQuery$data;
  variables: hasDevelopmentInProjectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "updatedFrom"
  }
],
v1 = {
  "kind": "Variable",
  "name": "from",
  "variableName": "projectAri"
},
v2 = {
  "kind": "Variable",
  "name": "updatedFrom",
  "variableName": "updatedFrom"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v4 = [
  {
    "concreteType": "AriGraphRelationship",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      }
    ]
  }
],
v5 = [
  {
    "concreteType": "DevOps",
    "kind": "LinkedField",
    "name": "devOps",
    "plural": false,
    "selections": [
      {
        "concreteType": "AriGraph",
        "kind": "LinkedField",
        "name": "ariGraph",
        "plural": false,
        "selections": [
          {
            "alias": "branchRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-branch"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "buildRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-build"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          },
          {
            "alias": "prRelationships",
            "args": [
              {
                "fields": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-pr"
                  },
                  (v2/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              (v3/*: any*/)
            ],
            "concreteType": "AriGraphRelationshipConnection",
            "kind": "LinkedField",
            "name": "relationships",
            "plural": false,
            "selections": (v4/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "hasDevelopmentInProjectQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hasDevelopmentInProjectQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "09268e1658eeaa570892ced33288a2210123505bca3c18bae5ebb8871931661b",
    "metadata": {},
    "name": "hasDevelopmentInProjectQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "237151dc451e5e360a3682a4990d5968";

export default node;
